import { styled } from 'baseui'
import { FlexColumn } from '@/shared/theme/styled-components'

export const Stack = styled(FlexColumn, {
  gap: '0.75rem',
})

export const FieldsColumn = styled('div', {
  maxWidth: '20rem',
  marginBottom: '0.75rem',
})

export const ActionsRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  marginTop: '0.75rem',
})

export const NotificationsWrapper = styled(FlexColumn, {
  marginTop: '0.75rem',
  gap: '0.5rem',
})
